import {
  getUpscCaArticleCmsPath,
  normalizeUpscCaArticleResponse
} from '@api/fetchers/upscCurrentAffairs/caArticles';
import { UPSC_FAQ_ITEMS_CMS_API_PATH } from '@api/fetchers/upscCurrentAffairs/faqItems';
import { UPSC_HERO_PAGES_CMS_API_PATH } from '@api/fetchers/upscCurrentAffairs/heroPages';
import getUpscCurrentAffairsPageSeoProps from './upscCurrentAffairsSeoInitialProps';
import { fetchUpscCmsData } from './upscCmsServerFetch';
import { resolveUpscArticlePageSeo } from './upscSeoUtils';

const DETAILED_PAGE_SWR_KEYS = {
  heroPages: UPSC_HERO_PAGES_CMS_API_PATH,
  faqItems: UPSC_FAQ_ITEMS_CMS_API_PATH
};

const getUpscDetailedPageGlobalFallbackData = async (articleId) => {
  const articleKey = getUpscCaArticleCmsPath(articleId);

  const [heroPages, faqItems, article] = await Promise.all([
    fetchUpscCmsData(DETAILED_PAGE_SWR_KEYS.heroPages),
    fetchUpscCmsData(DETAILED_PAGE_SWR_KEYS.faqItems),
    fetchUpscCmsData(articleKey)
  ]);

  const globalFallbackData = {};

  if (heroPages) {
    globalFallbackData[DETAILED_PAGE_SWR_KEYS.heroPages] = heroPages;
  }

  if (faqItems) {
    globalFallbackData[DETAILED_PAGE_SWR_KEYS.faqItems] = faqItems;
  }

  if (article) {
    globalFallbackData[articleKey] = article;
  }

  return globalFallbackData;
};

const getUpscDetailedPageInitialProps = (seoPageKey) => async (ctx) => {
  const { id } = ctx.query || {};
  const articleId = typeof id === 'string' ? id : null;

  const [seoProps, globalFallbackData] = await Promise.all([
    getUpscCurrentAffairsPageSeoProps(seoPageKey)(ctx),
    articleId
      ? getUpscDetailedPageGlobalFallbackData(articleId)
      : Promise.resolve({})
  ]);

  const articleKey = articleId ? getUpscCaArticleCmsPath(articleId) : null;
  const article = articleKey
    ? normalizeUpscCaArticleResponse(globalFallbackData[articleKey])
    : null;

  return {
    ...seoProps,
    upscPageSeo: resolveUpscArticlePageSeo(seoProps.upscPageSeo, article),
    globalFallbackData
  };
};

export default getUpscDetailedPageInitialProps;
